
<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator" 
             v-if="info.User && (info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.materialCreate) || info.ProjectsLength > 1 || $route.query.folderId)">
            <div class="control-block-left">
                <div class="flex">
                    <p class="btn-back margin-right-10" v-if="$route.query.folderId">
                        <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                    </p>
                    <project-select :user="info.User" @onChange="onProjectChange"
                                    v-if="(info.User.MainRole === 'administrators' || info.ProjectsLength > 1)"></project-select>
                </div>
            </div>
            <div class="control-block-right" v-if="hasClaims(info.User.DynamicRole, claimEnums.materialCreate) || info.User.MainRole === 'administrators'">
                <div class="btns flex" data-toggle="buttons">
                    <button class="btn btn-news" @click="addFolder">Добавить папку</button>
                    <button class="btn btn-news" @click="addMaterial">Добавить материал</button>
                    <button class="btn btn-news" @click="goToCertificate" v-if="enabledCertificate">Выдача сертификатов</button>
                    <div class="switch margin-left-10">
                        <input type="checkbox" id="s5" checked="checked" v-model="active" @change="reload" />
                        <label class="slider-v3" for="s5"></label>
                    </div>
                </div>
            </div>
        </div>

        <div class="body-panel-content body-panel-content-page panel-block-news no-padding-right">
            <div class="body-panel-content-center">
                <div style="width:100%">
                    <div class="materials-info" v-if="materialStats">
                        <div class="materials-info-item">
                            <div class="doughnut-wrap">
                                <chart v-if="chartData.length > 0" :chartData="chartData[0]" :chartOptions="chartOptions[0]" :type="'doughnut'" :key="'1'"></chart>
                            </div>
                            <div class="margin-left-10">
                                {{materialStats.learnedMaterials}}/{{materialStats.allMaterials}}<br>
                                Изучено<br>
                                материалов
                            </div>
                        </div>
                        <div class="materials-info-item">
                            <div class="doughnut-wrap">
                                <chart v-if="chartData.length > 1" :chartData="chartData[1]" :chartOptions="chartOptions[1]" :type="'doughnut'" :key="'2'"></chart>
                            </div>
                            <div class="margin-left-10">
                                {{materialStats.passedTests}}/{{materialStats.allTests}}<br>
                                Пройдено<br>
                                тестов
                            </div>
                        </div>
                        <div class="materials-info-item">
                            <div class="doughnut-wrap">
                                <chart v-if="chartData.length > 2" :chartData="chartData[2]" :chartOptions="chartOptions[2]" :type="'doughnut'"></chart>
                            </div>
                            <div class="margin-left-10">
                                Средний<br>
                                процент верных<br>
                                ответов
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="['panel-block panel-block-new', { 'learned': item.Complete }, {'not-read': !item.ReadByUser}]" v-for="item of materials" @click="onItemClick(item)">
                    <div class="panel-block-img-base">
                        <div class="panel-block-img">
                            <img :src="item.ImagePath" v-if="item.ImagePath" :style="getImageStyleFormatted(item.ImageStyle)" />
                        </div>
                    </div>
                    <div class="panel-block-info">
                        <p class="panel-block-header margin-bottom-10">{{ item.Name }}</p>
                        <p class="block-descr">{{ item.Category }}</p>
                        <p class="block-progress">{{ item.ProgressStatus }}</p>
                    </div>
                    <div class="panel-body-actions flex" v-if="!item.IsFolder">
                        <div class="panel-body-actions-part">
                            <button class="btn" @click.stop="goToMaterial(item.Id)">{{ item.ViewButtonName || 'Просмотр' }}</button>
                            <div @click.stop="goToMaterialEdit(item.Id)" class="btn btn-img"
                                 v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.materialCreate) || info.User.MainRole === 'administrators')">
                                <img src="../../img/pencil-edit-button.png" alt="" />
                            </div>
                        </div>
                        <div class="panel-body-actions-part">
                            <div v-if="item.CertificateSettings && item.CertificateSettings.Issuance!=='undefined' && item.CertificateSettings.Issuance.Actived" class="panel-body-actions-info">
                                <svg :class="['svg-icon', {'active': item.CertificateExists === true && !(hasClaims(info.User.DynamicRole, claimEnums.materialCreate) || info.User.MainRole === 'administrators')}]" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Sert"></use>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="panel-body-actions" v-if="item.IsFolder">
                        <button class="btn" @click.stop="goToFolder(item.Id)">{{ item.ViewButtonName || 'Просмотр' }}</button>
                        <a href="" @click.stop="goToFolderEdit(item.Id)" class="btn btn-img"
                           v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.materialCreate) || info.User.MainRole === 'administrators')">
                            <img src="../../img/pencil-edit-button.png" alt="" />
                        </a>
                    </div>

                    <div class="panel-body-stats" v-if="item.LikesEnabled">
                        <p @click.stop="onMakeMark(item, i)" title="Нравится" :class="['news-actions like', {'bold': item.MyVote === true}]">
                            <svg class="svg-icon like-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/Content/dist/image_svg.svg#Like"></use>
                            </svg>
                            <svg class="svg-icon like-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/Content/dist/image_svg.svg#Like2"></use>
                            </svg>
                            <span style="font-weight:400;line-height:1.3">{{item.LikesCount}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import claimsCheckingMixin from '../helpers/claims-checking-mixin'
    import UI from '../helpers/ui-helpers'
    import Vue from 'vue'

    let backendApi = new BackendApi();
    let cacheKey = 'materialsState';
    const pageSize = 12;

    export default {
        name: "materials",

        props: ['info'],

        mixins: [projectMixin, claimsCheckingMixin],

        data(){
            return{
                materials: [],
                page: 1,
                projectId: null,
                canBeLoaded: true,
                loading: false,
                chartData: [],
                chartOptions: [],
                materialStats: null,
                enabledCertificate: false,
                active: true,
            }
        },

        watch: {
            '$route.query.folderId'(to, from) {
                this.page = 1;
                this.materials = [];
                this.canBeLoaded = true;
                this.enabledCertificate = false;

                this.loadNext();
            }
        },

        methods: {
            reload() {
                this.clearFilterState();
                this.page = 1;
                this.materials = [];
                this.canBeLoaded = true;
                this.enabledCertificate = false;

                this.loadNext();
                this.loadStats();
            },
            back() {
                this.$router.back();
            },

            getImageStyleFormatted(imageStyle){
                if(!imageStyle){
                    return null;
                }

                let settings = {
                    left: imageStyle.left + '%',
                    top: imageStyle.top + '%',
                    transform: 'translateY(' + imageStyle.translateY + '%) translateX(' +
                    imageStyle.translateX + '%)'
                };
                if(imageStyle.resizeType === 1 && parseInt(imageStyle.size)){
                    settings.height = imageStyle.size + '%';
                }
                if(imageStyle.resizeType === 2 && parseInt(imageStyle.size)){
                    settings.width = imageStyle.size + '%';
                }
                return settings;
            },

            loadNext(){
                let vm = this;

                this.loading = true;
                UI.blockUI('.dataContent', 'Загрузка...');
                let folderId = vm.$route.query.folderId;
                this.callApiWrapper(backendApi.materialsList((this.page - 1) * pageSize, pageSize, vm.projectId, folderId, vm.active))
                    .then(function (resp) {
                        if(resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки материалов');
                        }
                        else{
                            if(resp.data && resp.data.length){
                                for(let item of resp.data){
                                    if (item.ImageStyle) {
                                        item.ImageStyle = JSON.parse(item.ImageStyle);
                                    }
                                    if (item.CertificateSettings) {
                                        item.CertificateSettings = JSON.parse(item.CertificateSettings);
                                        vm.enabledCertificate = vm.enabledCertificate || item.CertificateSettings.Issuance !== 'undefined' && item.CertificateSettings.Issuance.Actived;
                                    }
                                }
                                vm.materials.push(...resp.data);
                            }
                            else{
                                vm.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;
                    })
            },

            addMaterial() {
                let folderId = this.$route.query.folderId;
                this.$router.push('/materials/edit/0' + (folderId ? '?folderId=' + folderId : ''));
            },

            addFolder(){
                let folderId = this.$route.query.folderId;
                this.$router.push('/materials/folder/edit/0'+ (folderId ? '?folderId=' + folderId : ''));
            },

            goToCertificate() {
                let folderId = this.$route.query.folderId;
                this.$router.push('/materials/certificate/' + this.projectId + '/' + (folderId ? '?folderId=' + folderId : ''));
            },

            goToMaterial(id){
                this.saveFilterState();
                this.$router.push('/materials/' + id);
            },

            goToFolder(id) {
                this.saveFilterState();
                this.$router.push('/materials/?folderId=' + id);
            },

            goToMaterialEdit(id) {
                this.saveFilterState();
                this.$router.push('/materials/edit/' + id);
            },

            goToFolderEdit(id) {
                this.saveFilterState();
                this.$router.push('/materials/folder/edit/' + id);
            },

            onItemClick(item){
                if(item.IsFolder){
                    this.$router.push('/materials/?folderId=' + item.Id);
                }
                else{
                    this.$router.push('/materials/' + item.Id);
                }
            },

            onProjectChange(item){
                this.projectId = item.Id;
                this.reload();
                this.$emit('user-updated');
            },
            
            loadStats(){
                let vm = this;
                let prj_color = UI.project_colors(vm.projectId);
                UI.blockUI('.dataContent', 'Загрузка...');

                this.callApiWrapper(backendApi.materialStats(vm.projectId))
                    .then(function (resp) {
                        if(resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки статистики');
                        }
                        else{
                            let defaultChartOptions = {
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                    yAxes: [{
                                        display: false,
                                        ticks: {
                                            beginAtZero:true
                                        }
                                    }]
                                },
                                animation: {
                                    animateScale: true,
                                    animateRotate: true
                                },
                                cutoutPercentage: 90,
                                tooltips: {
                                    enabled: false
                                }
                            };
                            
                            vm.chartOptions = [
                                Object.assign({}, defaultChartOptions, {
                                    elements:{
                                        center:{
                                            text: resp.data.learnedPercent +'%',
                                            color: prj_color,
                                            fontStyle: "'Segoe UI'", 
                                            fontSize: 20,
                                            sidePadding: 20
                                        }
                                    }
                                }),
                                Object.assign({}, defaultChartOptions, {elements:{center:{
                                            text: resp.data.testsPercent +'%',
                                    color: prj_color, fontSize: 20,
                                    fontStyle: "'Segoe UI'",
                                            sidePadding: 20}}}),
                                Object.assign({}, defaultChartOptions, {elements:{center:{
                                            text: resp.data.rightAvgPercent +'%',
                                    color: prj_color, fontSize: 20,
                                    fontStyle: "'Segoe UI'",
                                            sidePadding: 20}}})
                            ];
                            vm.chartData = [
                                {
                                    datasets: [{
                                        data: [
                                            resp.data.learnedPercent,
                                            100 - resp.data.learnedPercent,
                                        ],
                                        backgroundColor: [
                                            prj_color, 'rgb(234, 235, 240)'
                                        ],
                                        borderWidth: 0
                                    }],
                                    labels:[]
                                },
                                {
                                    datasets: [{
                                        data: [
                                            resp.data.testsPercent,
                                            100 - resp.data.testsPercent,
                                        ],
                                        backgroundColor: [
                                            prj_color, 'rgb(234, 235, 240)'
                                        ],
                                        borderWidth: 0
                                    }],
                                    labels:[]
                                },
                                {
                                    datasets: [{
                                        data: [
                                            resp.data.rightAvgPercent,
                                            100 - resp.data.rightAvgPercent,
                                        ],
                                        backgroundColor: [
                                            prj_color, 'rgb(234, 235, 240)'
                                        ],
                                        borderWidth: 0
                                    }],
                                    labels:[]
                                }
                            ];

                            vm.materialStats = resp.data;
                        }
                        UI.unblockUI('.dataContent');
                    })
            },

            onMakeMark(item, index) {
                let vm = this;

                backendApi.materialMakeVote(item.Id).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при выполнении запроса. Попробуйте позже');
                    } else {
                        item.MyVote = !item.MyVote;
                        item.LikesCount = response.data.LikesCount;
                        Vue.set(vm.materials, index, item);
                    }
                });
            },

            saveFilterState() {
                let stateObj = {
                    projectId: this.projectId,
                    active: this.active,
                    folderId: this.$route.query.folderId,
                    page: this.page,
                };
                sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
            },

            recoverFilterState() {
                let stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
                if (stateObj) {
                    if ((stateObj.folderId == null || stateObj.folderId == this.$route.query.folderId) && (stateObj.projectId == this.projectId)) {
                        this.active = stateObj.active;
                        if (stateObj.page) {
                            this.page = stateObj.page;
                        }
                    }
                    else {
                        console.info(`recoverFilterState -> wrong folderId (stateObj.folderId = ${stateObj.folderId}) or projectId (${stateObj.projectId})`);
                    }
                    this.clearFilterState();
                }
            },

            clearFilterState() {
                sessionStorage.removeItem(cacheKey);
            }
        },

        mounted() {
            let vm = this;

            vm.recoverFilterState();

            this.loadNext();
            this.loadStats();

            vm.$nextTick(() => {

                $('.body-panel-content').on('scroll', function () {

                    if(!vm.loading && vm.canBeLoaded) {
                        let elem = $(this);
                        if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });
            });
        },

        destroyed(){
            $('.body-panel-content').off('scroll');
        }
    }
</script>



// WEBPACK FOOTER //
// Content/src/views/Materials.vue